import About from "../about/About";
import Login from "../auth/Login";
import { BrowserRouter, Routes, Route, Link, Navigate } from "react-router-dom";
import InterviewPage from "../interview/InterviewPage";
import AllDocuments from "../pages/AllDocuments";
import { useState, useEffect } from "react";
import DriveDocuments from "../pages/DriveDocuments";
import ChatWidget from '../ChatWidget';
import AllDocumentsNew from "../pages/AllDocumentsNew";
import DailyLearning from "../dailylearn/DailyLearning";
import {
  saveTaskToFirebase,
  getTodayTasks,
  deleteTaskFromFirebase,
  updateTaskInFirebase,
  getCategoriesFromFirebase,
  removeCategoryFromFirebase,
  renameCategoryInFirebase,
  addCategoryToFirebase
} from "../../firebase";

export default function Routing() {
  const [loggedIn, setLoggedin] = useState(false);
  const [showTaskDropdown, setShowTaskDropdown] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [customTaskName, setCustomTaskName] = useState("");
  const [taskNote, setTaskNote] = useState("");
  const [hours, setHours] = useState("");
  const [taskList, setTaskList] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [showSummaryDrawer, setShowSummaryDrawer] = useState(false);
  const [categories, setCategories] = useState([]);

  const fetchData = async () => {
    try {
      const [tasks, cats] = await Promise.all([getTodayTasks(), getCategoriesFromFirebase()]);
      setTaskList(tasks);
      setCategories(cats || []);
    } catch (error) { console.error("Error fetching data:", error); }
  };

  useEffect(() => { if (loggedIn) fetchData(); }, [loggedIn]);

  const handleDeleteCategoryMaster = async (e, catName) => {
    e.stopPropagation();
    if (window.confirm(`Permanently delete "${catName}"?`)) {
      await removeCategoryFromFirebase(catName);
      fetchData();
    }
  };

  const handleRenameCategoryMaster = async (e, oldName) => {
    e.stopPropagation();
    const newName = prompt("Rename category to:", oldName);
    if (newName && newName !== oldName) {
      await renameCategoryInFirebase(oldName, newName);
      fetchData();
    }
  };

  const handleTaskClick = (taskType) => {
    setEditingId(null);
    setSelectedTask(taskType);
    setCustomTaskName(taskType === "Custom" ? "" : taskType);
    setShowTaskDropdown(false);
    setTaskNote("");
    setHours("");
  };

  const handleSaveTask = async () => {
    const finalCategory = customTaskName || selectedTask;
    if (!taskNote || !hours || !finalCategory) return alert("Fill all fields!");

    try {
      const payload = {
        category: finalCategory,
        notes: taskNote,
        duration: hours,
        time: new Date().toLocaleTimeString()
      };

      if (editingId) {
        await updateTaskInFirebase({ ...payload, id: editingId });
      } else {
        await saveTaskToFirebase(payload);
        if (selectedTask === "Custom" && !categories.includes(finalCategory)) {
          await addCategoryToFirebase(finalCategory);
        }
      }
      setSelectedTask(null); setCustomTaskName(""); setTaskNote(""); setHours(""); setEditingId(null);
      fetchData();
    } catch (error) { alert("Error saving."); }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this log entry?")) {
      await deleteTaskFromFirebase(id);
      fetchData();
    }
  };

  const startEdit = (task) => {
    setEditingId(task.id);
    setSelectedTask("Rename Mode");
    setCustomTaskName(task.category);
    setHours(task.duration);
    setTaskNote(task.notes);
    setShowSummaryDrawer(false);
  };

  const textAreaStyle = {
    width: '100%', padding: '12px', borderRadius: '4px', border: '1px solid #000',
    fontSize: '14px', fontFamily: 'inherit', outline: 'none', resize: 'vertical', boxSizing: 'border-box'
  };

  return (
    <BrowserRouter>
      <div style={{ padding: "10px 20px", position: "relative", zIndex: 10 }}>
        {loggedIn && (
          <>
            {/* ✅ Responsive Nav Container */}
            <nav style={{
              display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '15px',
              borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '20px'
            }}>
              <Link to="/" style={{ color: '#007bff', textDecoration: 'none', fontWeight: 'bold' }}>Home</Link>
              <Link to="/alldocuments" style={{ color: '#333', textDecoration: 'none' }}>All documents</Link>
              <Link to="/drivedocuments" style={{ color: '#333', textDecoration: 'none' }}>DriveDocuments</Link>
              <Link to="/dailylearning" style={{ color: '#333', textDecoration: 'none' }}>Learn</Link>
            </nav>

            {/* ✅ Responsive Modal */}
            {selectedTask && (
              <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 2000 }}>
                <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '8px', width: 'min(90%, 500px)', maxHeight: '90vh', overflowY: 'auto' }}>
                  <h3 style={{ marginTop: 0, color: '#007bff' }}>{editingId ? "Update Task" : `Log: ${selectedTask}`}</h3>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    {(selectedTask === "Custom" || editingId) && (
                      <input type="text" placeholder="Task Name..." value={customTaskName} onChange={(e) => setCustomTaskName(e.target.value)} style={{ padding: '10px', borderRadius: '4px', border: '2px solid #007bff' }} />
                    )}
                    <input type="text" placeholder="Time Spent (e.g. 2hr)" value={hours} onChange={(e) => setHours(e.target.value)} style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }} />
                    <textarea placeholder="Notes..." rows="5" value={taskNote} onChange={(e) => setTaskNote(e.target.value)} style={textAreaStyle} />
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <button onClick={handleSaveTask} style={{ flex: 1, backgroundColor: '#28a745', color: 'white', border: 'none', padding: '12px', borderRadius: '4px', fontWeight: 'bold' }}>Save</button>
                      <button onClick={() => { setSelectedTask(null); setEditingId(null); }} style={{ flex: 1, background: '#dc3545', color: 'white', border: 'none', padding: '12px', borderRadius: '4px' }}>Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* ✅ Responsive Side Drawer */}
            <div style={{
              position: 'fixed', right: showSummaryDrawer ? 0 : '-100%', top: 0, width: 'min(100%, 400px)', height: '100%',
              backgroundColor: '#fff', boxShadow: '-5px 0 15px rgba(0,0,0,0.1)', zIndex: 1500,
              transition: 'right 0.3s ease-in-out', padding: '20px', overflowY: 'auto'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid #007bff', paddingBottom: '10px' }}>
                <h3 style={{ margin: 0 }}>Progress</h3>
                <button onClick={() => setShowSummaryDrawer(false)} style={{ border: 'none', background: 'none', fontSize: '24px', cursor: 'pointer' }}>✖</button>
              </div>
              {taskList.length === 0 ? <p>No tasks today.</p> : [...taskList].reverse().map(t => (
                <div key={t.id} style={{ marginBottom: '15px', padding: '15px', borderRadius: '8px', border: '1px solid #ddd', backgroundColor: '#f8f9fa' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '5px' }}>
                    <strong>{t.category}</strong>
                    <span>{t.time} | {t.duration}</span>
                  </div>
                  <textarea readOnly value={t.notes} style={{ ...textAreaStyle, height: '80px', border: '1px solid #ccc', backgroundColor: '#fff', resize: 'none' }} />
                  <div style={{ marginTop: '10px', textAlign: 'right' }}>
                    <button onClick={() => startEdit(t)} style={{ color: '#007bff', border: 'none', background: 'none', cursor: 'pointer', fontWeight: 'bold', marginRight: '15px' }}>Edit</button>
                    <button onClick={() => handleDelete(t.id)} style={{ color: 'red', border: 'none', background: 'none', cursor: 'pointer' }}>Delete</button>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      <Routes>
        <Route path="/" element={<Login setLoggedin={setLoggedin} />} />
        {loggedIn ? (
          <>
            <Route path="/alldocuments" element={<AllDocuments />} />
            <Route path="/drivedocuments" element={<AllDocumentsNew />} />
            <Route path="/interview" element={<InterviewPage />} />
            <Route path="/chat" element={<ChatWidget />} />
            <Route path="/dailylearning" element={<DailyLearning />}/>
          </>
        ) : <Route path="*" element={<Navigate to="/" replace />} />}
      </Routes>
    </BrowserRouter>
  );
}
